import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus,
    exportExcel,
} from "../../../../../services/adapters/kepegawaian/dukService"

class IndexRepository {

    fetchExportExcel = async (query) => {
        return await apiRequest("get", exportExcel, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }
}

export default IndexRepository